import React, { useContext } from "react"

import { AUTH_FLOW_COMPONENTS, AuthContext } from "../contexts/Auth"

import LoginForm             from "./LoginForm"
import RegistrationForm      from "./RegistrationForm"
import ForgotPasswordForm    from "./ForgotPasswordForm"
import EmailVerificationForm from "./EmailVerification"

import as from "../styles/auth-styles.module.scss"

const DEFAULT_HEADING = "You must be logged in to access this page"


const AuthFlow = ({ heading = DEFAULT_HEADING }) => {

    const { currAuthComponent } = useContext(AuthContext)

    const getCurrComponent = () => {
        switch (currAuthComponent) {
            case AUTH_FLOW_COMPONENTS.REGISTER:
                return <RegistrationForm />
            case AUTH_FLOW_COMPONENTS.FORGOT_PASSWD:
                return <ForgotPasswordForm />
            case AUTH_FLOW_COMPONENTS.EMAIL_VERIFY:
                return <EmailVerificationForm/>
            default:
                return <LoginForm />
        }
    }

    return (
        <div>
            <h3 className={as['text-center']}>
                {heading}
            </h3>
            {getCurrComponent()}
        </div>
    )
}

export default AuthFlow